import {
  ALBUM_UPLOAD_REQUEST,
  ALBUM_UPLOAD_SUCCESS,
  ALBUM_UPLOAD_FAILURE,
  ALBUM_UPLOAD_PROGRESS,
  ALBUM_UPLOAD_RESET,
} from '../actions/album-upload';

const initialState = {
  total: 0,
  current: 0,
  error: '',
  success: false,
  uploading: false,
};

const albumUploadsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALBUM_UPLOAD_REQUEST:
      return {
        ...initialState,
        total: action.photos.length,
        uploading: true,
        error: '',
      };

    case ALBUM_UPLOAD_PROGRESS:
      return {
        ...state,
        current: state.current + 1,
      };

    case ALBUM_UPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
        success: true,
        error: '',
      };

    case ALBUM_UPLOAD_FAILURE:
      return {
        ...state,
        success: false,
        uploading: false,
        error: action.error.message,
      };

    case ALBUM_UPLOAD_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default albumUploadsReducer;
